import { selectGroup, fetchDepCategories, fetchCategories, editMultiGroups, deleteGroup, selectCategory, resetCurrentCategory, editMultiCategories, deleteCategory, clearDeleteCategoryStatus, fetchGroupCategories } from '../../actions/products_actions';
import { connect } from 'react-redux';

import Groupies from '../../components/Products/groupies'

function mapStateToProps(state) {
    return {
        categories: state.products.groupCategories,
        depCategories: state.products.depCategories,
        categoryIsLoading: state.products.groupCategoryIsLoading,
        categoryError: state.products.groupCategoryError,
        currentCategory: state.products.currentCategory,

        multiIsEditing: state.products.multiCategoryIsEditing,
        multiError: state.products.multiCategoryEditError,
        multiEdited: state.products.multiCategoryEdited,

        multiGroupIsEditing: state.products.multiGroupIsEditing,
        multiGroupEditError: state.products.multiGroupEditError,
        multiGroupEdited: state.products.multiGroupEdited,

        userPermissions: state.auth.userPermissions,

        deletingCategory: state.products.deletingCategory,
        deleteCategorySuccess: state.products.deleteCategorySuccess,
        deleteCategoryError: state.products.deleteCategoryError,
        deletingGroup: state.products.deletingGroup,
        deleteGroupSuccess: state.products.deleteGroupSuccess,
        deleteGroupError: state.products.deleteGroupError,

        currentGroup: state.products.currentGroup,
        currentDep: state.products.currentDep,
    };
}

export default connect(mapStateToProps, { fetchDepCategories, deleteGroup, editMultiGroups, fetchCategories, selectGroup, selectCategory, resetCurrentCategory, editMultiCategories, deleteCategory, clearDeleteCategoryStatus, fetchGroupCategories })(Groupies);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/groupies.jsx